import React from 'react';
import { Radio } from '@mui/material';

import './CustomRadioButton.scss';

interface CustomRadioButtonProps {
  name: string;
  id: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  text: string;
}

export default function CustomRadioButton({ name, id, value, onChange, checked, text }: CustomRadioButtonProps) {
  return (
    <label htmlFor={id} className="custom-radioLabel">
      <Radio
        id={id}
        sx={{ padding: 0 }}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disableRipple
      />
      &nbsp;&nbsp;{text}
    </label>
  );
}
